export default {
    Feed: axios.create({
      baseURL: process.env.VUE_APP_ENDPOINT_API + "feed"
    })
  }


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/Feed.js
// module id = JRta
// module chunks = 16